import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"
import { Draggable } from "react-beautiful-dnd"
import Checkbox from "../../../checkbox/checkbox.component"
import Icon from "../../../icon/icon.component"
import { DraggableItem } from "./ColumnSelectionModal"

interface OwnProps {
    item: DraggableItem
    index: number
    totalChecked?: boolean
    onToggleTotal: () => void
    onRemove: () => void
}

const DraggableItemComponent = (props: OwnProps) => {
    return (
        <Draggable
            key={props.item.id}
            draggableId={props.item.id}
            index={props.index}
        >
            {(provided, snapshot) => {
                const style = provided.draggableProps.style
                
                if (style) {
                    const transform = style.transform

                    if (transform) {
                        const ty = transform.split(",")[1]
                        style.transform = "translate(0px," + ty
                        provided.draggableProps.style = style
                    }
                }

                return (
                    <div
                        className={`draggable-item ${snapshot.isDragging ? "dragging" : ""}`}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    >
                        <div className="draggable-content">
                            <div className="label">
                                <Icon value="bars" />
                                {props.item.content}
                            </div>
                            {props.item.hasTotal ? (
                                <div className="total">
                                    <FontAwesomeIcon icon="calculator" />
                                    <Checkbox
                                        checked={props.totalChecked}
                                        onChange={props.onToggleTotal}
                                    />
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                        <a role="button" className={props.item.removable ? "" : "disabled"} onClick={props.onRemove}>
                            <FontAwesomeIcon icon="times" />
                        </a>
                    </div>
                )
            }}
        </Draggable>
    )
}

export default DraggableItemComponent


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/header-selection/DraggableItem.tsx